import { useState, useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { deleteFile } from "../../../../apis/common-apis/fileApi";

export const useAuditPlanDelete = ({ onSuccess, onError } = {}) => {
  const { getAccessTokenSilently, getIdTokenClaims } = useAuth0();
  const [deleting, setDeleting] = useState(false);

  const deletePlanFile = useCallback(
    async (fileUuid) => {
      if (!fileUuid) return;
      setDeleting(true);
      try {
        const accessToken = await getAccessTokenSilently();
        const idToken = (await getIdTokenClaims()).__raw;
        await deleteFile(fileUuid, accessToken, idToken);
        onSuccess?.();
      } catch (err) {
        console.error("Audit plan delete failed:", err);
        onError?.(err.message || "Failed to delete audit plan file");
      } finally {
        setDeleting(false);
      }
    },
    [getAccessTokenSilently, getIdTokenClaims, onError, onSuccess]
  );

  return { deleting, deletePlanFile };
};
